module.exports = __webpack_public_path__ + "fonts/effect-crowd-pleasers-4bd971.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-crowd-pleasers.svg
// module id = 732
// module chunks = 0